module.exports = __webpack_public_path__ + "img/log-page.e600d485.svg";